<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

     <vx-card title="Preferences" class="mb-base">

      <div class="vx-row">
        <div class="avatar-img img-container mb-4 ml-4" v-if="files.length > 0">
          <img :src="files[0]" class="rounded w-full" />
        </div>
        <div class="avatar-img img-container mb-4 ml-4" v-else>
          <img src="/img/a1.d70cfb2b.jpeg" class="rounded w-full" />
        </div>

        <!-- <div class="avatar-img img-container mb-4 ml-4">
          <img src="/img/a2.c8c0e65e.svg" class="rounded w-full" />
        </div> -->
      </div>

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ view_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Address</td>
                <td>{{ view_data.address_line_1 }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Type</td>
                <td>{{ view_data.property_type }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Radius</td>
                <td>{{ view_data.radius }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
           <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-property-edit', params: { editId: $route.params.viewId }}" 
            :disabled="!showU">Edit <!-- crud -->
            </vs-button> 
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
            :disabled="!showD">Delete <!-- crud -->
            </vs-button>
          </div>

        </div>

      </vx-card>

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-property-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <div>

      <!-- <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property Manager Assigned" class="mb-base">
            <PropertyManagerList></PropertyManagerList>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property User Assigned" class="mb-base">
            <PropertyUserList></PropertyUserList>
          </vx-card>
        </div>
      </div> -->

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Amenity List" class="mb-base">
            <AmenityList></AmenityList>
          </vx-card>
        </div>

        <!-- <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property Assigned" class="mb-base">
            <PropertyManagerList></PropertyManagerList>
          </vx-card>
        </div> -->
      </div>

<!--       <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Contacts" class="mb-base">
            <agGridContacts></agGridContacts>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="PMC Contacts" class="mb-base">
            <agGridPmcContacts></agGridPmcContacts>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Staff" class="mb-base">
            <agGridStaff></agGridStaff>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Staff Categories" class="mb-base">
            <agGridStaffCategories></agGridStaffCategories>         
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Board Member Types" class="mb-base">
            <agGridBoardMemberTypes></agGridBoardMemberTypes>            
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Unit Attributes" class="mb-base">
            <agGridUnitAttributes></agGridUnitAttributes>            
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Parking Stalls" class="mb-base">
            <agGridParkingStalls></agGridParkingStalls>            
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Folder Categories" class="mb-base">
           <agGridFolderCategories></agGridFolderCategories>            
          </vx-card>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

import agGridAmenities from './agGrid-amenities/agGrid.vue'
import agGridBoardMemberTypes from './agGrid-boardMemberTypes/agGrid.vue'
import agGridContacts from './agGrid-contacts/agGrid.vue'
import agGridFolderCategories from './agGrid-folderCategories/agGrid.vue'
import agGridParkingStalls from './agGrid-parkingStalls/agGrid.vue'
import agGridPmcContacts from './agGrid-pmcContacts/agGrid.vue'
import agGridStaff from './agGrid-staff/agGrid.vue'
import agGridStaffCategories from './agGrid-staffCategories/agGrid.vue'
import agGridUnitAttributes from './agGrid-unitAttributes/agGrid.vue'
import agGridZones from './agGrid-zones/agGrid.vue'
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud

import AmenityList from './amenity/list/List.vue'
import PropertyManagerList from './property-manager/list/List.vue'
import PropertyUserList from './property-user/list/List.vue'

export default {
  components: {
    agGridAmenities,
    agGridBoardMemberTypes,
    agGridContacts,
    agGridFolderCategories,
    agGridParkingStalls,
    agGridPmcContacts,
    agGridStaff,
    agGridStaffCategories,
    agGridUnitAttributes,
    agGridZones,

    AmenityList,
    PropertyManagerList,
    PropertyUserList
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      token: token,
      view_data: {
        name: '',
        address_line_1: '',
        address_line_2: '',
        city: '',
        postal_code: '',
        state: '',
        country_id: 0,
        radius: '',
        code: '',
        is_deleted: 0,
        created_by_manager_id: 0,
        manager_id: 0,
        property_type: '',
        permissions1_json: '',
        permissions2_json: '',
        domain: '',
        pmc_id: 0,
        photo_filename: '',
        ref: '',
        settings_json: '',
        email_signature: '',
        caliber_client_id: 0,
        BillingAddress1: '',
        BillingAddress2: '',
        BillingAddress3: '',
        BillingCity: '',
        BillingCountry: '',
        BillingFax: '',
        BillingPhoneArea: '',
        BillingPhone: '',
        BillingPhoneType: '',
        BillingState: '',
        BillingZip: '',
      },

      user_data: null,
      user_not_found: false,
      data_not_found: false,

      //reading docs
      tableRead: [],
      files: []
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field  } `
      }
      return str
    }
  },
  methods: {
    //reading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.$router.push({name:'app-user-list'})
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    loadData () {
      this.$vs.loading()

      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/property/view/property_ref/${localStorage.selectedParentOrgRef}`, {
            headers: { 
              'Authorization': this.token,
              'property_ref': localStorage.selectedParentOrgRef 
            }
          })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-property-list'})
              } else {
                resolve(res['data'])
              }

              // this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            }) 

            //reading docs
            this.tableRead = await axios.post(`/docs/table/read/`, {
              token: this.token,
              path: `docs/property/avatar/${viewId}`,
              document_folder_id: 26
            })

            //reading docs
            for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
              var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
              var imgAsc = imgB64.toString('ascii')
              this.files.push("data:image/png;base64, " + imgAsc)
            }
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.view_data = res[0]
          this.$vs.loading.close()
          console.log('this.view_data ', this.view_data)
        })
      })
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('property-list', 'list')
    this.showC = await mainHelper.cansee('property-create', 'create')
    this.showR = await mainHelper.cansee('property-read', 'read')
    this.showU = await mainHelper.cansee('property-update', 'update')
    this.showD = await mainHelper.cansee('property-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }
    
    this.loadData()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

</style>
